import { User } from '@/graphql/types';
import userflow from 'userflow.js';

/**
 * Initializes the Userflow tracking service for the logged-in user.
 *
 * This function checks if the USERFLOW_TOKEN is available, and if so,
 * initializes the Userflow SDK and identifies the user by their ID.
 * It also sends additional metadata such as name, email, and signup timestamp.
 *
 * @param loggedInUser - The authenticated user object containing user details.
 * Must include an `id` to proceed with identification.
 *
 * @remarks
 * - Logs a warning if USERFLOW_TOKEN is not set.
 * - No action is taken if `loggedInUser` is undefined or missing an `id`.
 */

export const initUserFlow = async (USERFLOW_TOKEN: string) => {
  userflow.init(USERFLOW_TOKEN);
};

export const identifyUserFlow = async (loggedInUser?: User, locale?: string) => {
  if (loggedInUser?.id) {
    userflow.identify(loggedInUser.id.toString(), {
      name: loggedInUser.name,
      email: loggedInUser.email,
      signed_up_at: new Date().toISOString(),
      ...(locale && { locale_code: locale }),
    });
  }
};

export const clearUserFlow = () => {
  userflow.reset();
};
